// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"630":"b970e7f2","935":"c373489c"}[chunkId] + ".css";
};